import { mapGetters, mapActions } from 'vuex';
import mapper from '../../../common/store/mapper/index.js';
import { setSessionStorage, getSessionStorage } from '../../../common/utilities/nojq/_localstorage.js';

function getPropertyList(arr, state){
    if(arr && arr.length){
        return arr.map(function(e){
           return mapper.property(e, state);
        });
    }
    return [];
}

export default {
    name: 'agentTransactionDetail',
    inject: ['$eventBus'],
    props: {
        agentId: {
            type: String,
            default: ''
        }
    },
    computed:{
        ...mapGetters('dap', ['dap']),
        ...mapGetters('glb', ['glb']),
        getlistings() {
            return this.listings || []
        },
        disabledPrevArrow() {
            return this.currentPage === 1;
        },
        disableNextArrow() {
            return this.currentPage === this.totalPage;
        },
        nolistingsAfterLoad() {
            return !this.isLoading && !this.getlistings.length
        },
        showContent() {
            return (this.isLoading || this.totalPage > 1 || this.getlistings.length)
        }
    },
    data(){
        return {
            listings: [],
            agentRepresentation: [],
            currentPage: 1,
            totalPage: 1,
            isLoading: false,
        };
    },
    methods: {
        ...mapActions('dap', ['fetchRecentTransForAgentByPage']),
        loadListings(page) {
            const that = this;
            this.isLoading = true;
            let param = {
              agentId: this.agentId,
              page: page,
              limit: 5
            }
            this.fetchRecentTransForAgentByPage(param).then(function(res){
                if(res && res.status && res.status.code == 0 && res.data) {
                    that.listings =  res.data.transactions && res.data.transactions.length ? getPropertyList(res.data.transactions, that.glb) : [];
                    that.agentRepresentation = res.data.agentRepresentation || []
                    that.totalPage = res.data.totalCount ? Math.ceil(res.data.totalCount / param.limit) : 1
                    that.setCurrentPage(page)
                    that.isLoading = false
                }
            });
        },
        setCurrentPage(page) {
            this.currentPage = page
            let data = {'page': page, 'url': this.glb.url}
            setSessionStorage('agentPage', JSON.stringify(data));
        },
        goPrev() {
            return this.loadListings(this.currentPage -1);
        },
        goNext() {
            return this.loadListings(this.currentPage +1);
        },
        getRepresentedStatus(propertyId) {
            let rep = this.agentRepresentation && this.agentRepresentation.length && this.agentRepresentation.find(rep=> rep.propertyId == propertyId)
            let transactiontype = rep.transactionType == 'DUAL' ? 'BOTH' : rep.transactionType
            return transactiontype && transactiontype.toLowerCase() || '-'
        }
    },
    mounted(){
        let storage = getSessionStorage('agentPage') && JSON.parse(getSessionStorage('agentPage'))
        this.currentPage = (storage && storage.url == this.glb.url) ? storage.page : 1
        this.loadListings(this.currentPage)
    }
};